import { isWorkplaceRequestsEnabled } from "@gettactic/helpers/src/featureFlags";
import { useOrgFeatureFlag } from "@gettactic/hooks";
import { MAP_PIN_REQUEST_ENABLED } from "@/features/map/mapPinRequest.config";

/**
 * Whether the "drop a pin to file a workplace request" map affordance is
 * available: the experimental master switch AND the org's workplace-requests
 * feature flag (dropping a request pin only makes sense when the feature is on).
 */
export const useIsMapPinRequestEnabled = (): boolean => {
  const workplaceRequestsFeatureFlag = useOrgFeatureFlag("workplace_requests");
  return (
    MAP_PIN_REQUEST_ENABLED &&
    isWorkplaceRequestsEnabled(workplaceRequestsFeatureFlag)
  );
};
